import React from 'react';
import { Helmet } from 'react-helmet';

const UnexpectedErrorScreen = () => (
   <>
      <Helmet>
         <title>Unexpected Error</title>
      </Helmet>

      <div className="container">
         <h1 className="mt-4">Unexpected Error</h1>
         <p>
            Reload this page and try again later. Contact support if you
            continue to experience this error.
         </p>
      </div>
   </>
);

export { UnexpectedErrorScreen };
